<template>
  <vf-utility-navigation v-bind="forwarded">
    <template #loyalty v-if="$feature.tempShowLoyaltyAtBottomOfMenuOnMobile">
      <span class="md:hidden">
        {{ rewardsAvailable }}
      </span>
    </template>
  </vf-utility-navigation>
</template>

<script lang="ts" setup>
import type { Emits, Props } from '#brand/regions/nora/components/vf/utility-navigation/UtilityNavigation.vue'
import VfUtilityNavigation from '#brand/regions/nora/components/vf/utility-navigation/UtilityNavigation.vue'

const props = defineProps<Props>()
const emits = defineEmits<Emits>()
const forwarded = useForwardPropsEmits(props, emits)

const auth = useAuthStore()
const loyalty = useLoyaltyStore()
const config = useAppConfig().components.cms.megaMenu
const { $feature, $pluralize, $t } = useNuxtApp()

whenever(() => auth.loggedIn, () => loyalty.getRewards(), { immediate: true })

const rewardsAvailable = computed(() =>
  loyalty.rewardsAvailable?.length
    ? ` | ${replaceAll(
      $pluralize(
        $t.loyaltyRewardsDetails.rewardsCount,
        loyalty.rewardsAvailable.length
      ),
      { amount: loyalty.rewardsAvailable.length }
    )}`
    : undefined
)

if ($feature.tempShowLoyaltyAtBottomOfMenuOnMobile)
  config.hideLoyaltyAccordion = true
</script>
